module.exports = __webpack_public_path__ + "static/media/dashboard.fe18b64c.png";